import React, { useEffect, useState } from "react";
import { Box, FormControl, Select, MenuItem, Typography } from "@mui/material";
import RequiredLabel from "../../shared/RequiredLabel";

const ApiSelect = ({
  value,
  onChange,
  currentUserId,
  endpoint,
  isRequired = true,
  label,
  error = false,
  blankLabel,
  disabled = false,
}) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    fetch(endpoint)
      .then((res) => res.json())
      .then((data) => {
        const list = Array.isArray(data)
          ? data
          : data?.departments ?? data?.users ?? data?.items ?? [];
        setOptions(Array.isArray(list) ? list : []);
        if (
          (value === undefined || value === null || value === "") &&
          currentUserId
        ) {
          onChange(currentUserId);
        }
      })
      .catch((err) => console.error(`${label}の取得エラー:`, err));
  }, [endpoint, currentUserId]);

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <Typography sx={{ fontSize: 14 }}>{label}</Typography>
        <RequiredLabel show={isRequired} />
      </Box>

      <FormControl sx={{ width: { xs: "100%", md: "45%" } }} error={error}>
        <Select
          value={value ?? ""}
          onChange={(e) =>
            onChange(e.target.value === "" ? null : e.target.value)
          }
          displayEmpty
          renderValue={(selected) => {
            if (!selected) return blankLabel;
            const selectedUser = options.find(
              (u) => String(u.id) === String(selected)
            );
            return selectedUser ? selectedUser.name : blankLabel;
          }}
          disabled={disabled}
          sx={{
            // disabled 時にだけ適用されるスタイル
            "& .MuiSelect-select.Mui-disabled": {
              backgroundColor: "#DDDDDD",
              color: "#777777",
              cursor: "not-allowed",
            },
          }}
        >
          <MenuItem value="">
            <em>{blankLabel}</em>
          </MenuItem>
          {options.map((user) => (
            <MenuItem key={user.id} value={user.id}>
              {user.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default ApiSelect;
